/**
 * Subtitle for the profile's "Recent works" card.
 *
 * Two live findings meet here. #32: the copy said "The five most recent items"
 * while three rendered — the resolver returns AT MOST five, so the number has to
 * come from what is actually on screen. #31: the whole profile is reused for
 * another member's record, where second-person copy ("your ORCID record") is
 * simply about the wrong person.
 *
 * Pure, and the count is passed in, so the component computes this once per load
 * into a field rather than re-deriving it from `workRows` on every
 * change-detection pass (ui-best-practices §7).
 */
export function RecentWorksSubtitle(count: number, isOrcid: boolean, isSelf: boolean): string {
    const possessive = isSelf ? 'your' : 'their';
    if (!isOrcid) {
        return isSelf ? 'Your most recent AGU works.' : 'Their most recent AGU works.';
    }
    if (count === 1) return `The most recent item on ${possessive} ORCID record.`;
    return `The ${count} most recent items on ${possessive} ORCID record.`;
}
